/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * LUMA Entertainment API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminCredentials,
  AdminListAffiliatesParams,
  AdminListEventsParams,
  AdminListPartnersParams,
  AdminUser,
  Affiliate,
  AffiliateInput,
  AffiliateLink,
  AffiliateLinkInput,
  AffiliateLinkUpdate,
  AffiliateUpdate,
  AnalyticsResult,
  BulkActionBody,
  BulkActionResult,
  ClickInput,
  ClickRecorded,
  ContactInput,
  ContactMessage,
  ContactResult,
  ContentBlocks,
  ContentUpdate,
  Event,
  EventInput,
  EventUpdate,
  GetAdminAnalyticsParams,
  HealthStatus,
  ListAffiliatesParams,
  ListEventsParams,
  ListPartnersParams,
  MessageUpdate,
  PageViewInput,
  PageViewRecorded,
  PaginatedAffiliates,
  PaginatedEvents,
  PaginatedPartners,
  Partner,
  PartnerInput,
  PartnerUpdate,
  ReorderBody,
  SetParticipantsBody,
  SimpleMessage,
  SiteSettings,
  SiteSettingsUpdate,
  UnreadCount,
  UpdateAdminCredentials,
  UploadedImage
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAffiliatesUrl = (params?: ListAffiliatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/affiliates?${stringifiedParams}` : `/api/affiliates`
}

/**
 * @summary List all active affiliates
 */
export const listAffiliates = async (params?: ListAffiliatesParams, options?: RequestInit): Promise<PaginatedAffiliates> => {

  return customFetch<PaginatedAffiliates>(getListAffiliatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAffiliatesQueryKey = (params?: ListAffiliatesParams,) => {
    return [
    `/api/affiliates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAffiliatesQueryOptions = <TData = Awaited<ReturnType<typeof listAffiliates>>, TError = ErrorType<unknown>>(params?: ListAffiliatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAffiliates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAffiliatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAffiliates>>> = ({ signal }) => listAffiliates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAffiliates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAffiliatesQueryResult = NonNullable<Awaited<ReturnType<typeof listAffiliates>>>
export type ListAffiliatesQueryError = ErrorType<unknown>


/**
 * @summary List all active affiliates
 */

export function useListAffiliates<TData = Awaited<ReturnType<typeof listAffiliates>>, TError = ErrorType<unknown>>(
 params?: ListAffiliatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAffiliates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAffiliatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAffiliateUrl = (slug: string,) => {




  return `/api/affiliates/${slug}`
}

/**
 * @summary Get affiliate by slug
 */
export const getAffiliate = async (slug: string, options?: RequestInit): Promise<Affiliate> => {

  return customFetch<Affiliate>(getGetAffiliateUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAffiliateQueryKey = (slug: string,) => {
    return [
    `/api/affiliates/${slug}`
    ] as const;
    }


export const getGetAffiliateQueryOptions = <TData = Awaited<ReturnType<typeof getAffiliate>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliate>>> = ({ signal }) => getAffiliate(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAffiliate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAffiliateQueryResult = NonNullable<Awaited<ReturnType<typeof getAffiliate>>>
export type GetAffiliateQueryError = ErrorType<void>


/**
 * @summary Get affiliate by slug
 */

export function useGetAffiliate<TData = Awaited<ReturnType<typeof getAffiliate>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAffiliateQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAffiliateLinksUrl = (slug: string,) => {




  return `/api/affiliates/${slug}/links`
}

/**
 * @summary Get obfuscated links for an affiliate
 */
export const getAffiliateLinks = async (slug: string, options?: RequestInit): Promise<AffiliateLink[]> => {

  return customFetch<AffiliateLink[]>(getGetAffiliateLinksUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAffiliateLinksQueryKey = (slug: string,) => {
    return [
    `/api/affiliates/${slug}/links`
    ] as const;
    }


export const getGetAffiliateLinksQueryOptions = <TData = Awaited<ReturnType<typeof getAffiliateLinks>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliateLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateLinksQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateLinks>>> = ({ signal }) => getAffiliateLinks(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAffiliateLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAffiliateLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getAffiliateLinks>>>
export type GetAffiliateLinksQueryError = ErrorType<void>


/**
 * @summary Get obfuscated links for an affiliate
 */

export function useGetAffiliateLinks<TData = Awaited<ReturnType<typeof getAffiliateLinks>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAffiliateLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAffiliateLinksQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListEventsUrl = (params?: ListEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events?${stringifiedParams}` : `/api/events`
}

/**
 * @summary List all active events
 */
export const listEvents = async (params?: ListEventsParams, options?: RequestInit): Promise<PaginatedEvents> => {

  return customFetch<PaginatedEvents>(getListEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEventsQueryKey = (params?: ListEventsParams,) => {
    return [
    `/api/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEventsQueryOptions = <TData = Awaited<ReturnType<typeof listEvents>>, TError = ErrorType<unknown>>(params?: ListEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({ signal }) => listEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>
export type ListEventsQueryError = ErrorType<unknown>


/**
 * @summary List all active events
 */

export function useListEvents<TData = Awaited<ReturnType<typeof listEvents>>, TError = ErrorType<unknown>>(
 params?: ListEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetEventUrl = (slug: string,) => {




  return `/api/events/${slug}`
}

/**
 * @summary Get event by slug
 */
export const getEvent = async (slug: string, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getGetEventUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventQueryKey = (slug: string,) => {
    return [
    `/api/events/${slug}`
    ] as const;
    }


export const getGetEventQueryOptions = <TData = Awaited<ReturnType<typeof getEvent>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) => getEvent(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventQueryError = ErrorType<void>


/**
 * @summary Get event by slug
 */

export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecordClickUrl = () => {




  return `/api/clicks`
}

/**
 * @summary Record a link click (for analytics)
 */
export const recordClick = async (clickInput: ClickInput, options?: RequestInit): Promise<ClickRecorded> => {

  return customFetch<ClickRecorded>(getRecordClickUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      clickInput,)
  }
);}




export const getRecordClickMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordClick>>, TError,{data: BodyType<ClickInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordClick>>, TError,{data: BodyType<ClickInput>}, TContext> => {

const mutationKey = ['recordClick'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordClick>>, {data: BodyType<ClickInput>}> = (props) => {
          const {data} = props ?? {};

          return  recordClick(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordClickMutationResult = NonNullable<Awaited<ReturnType<typeof recordClick>>>
    export type RecordClickMutationBody = BodyType<ClickInput>
    export type RecordClickMutationError = ErrorType<unknown>

    /**
 * @summary Record a link click (for analytics)
 */
export const useRecordClick = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordClick>>, TError,{data: BodyType<ClickInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordClick>>,
        TError,
        {data: BodyType<ClickInput>},
        TContext
      > => {
      return useMutation(getRecordClickMutationOptions(options));
    }

export const getRecordPageViewUrl = () => {




  return `/api/page-views`
}

/**
 * @summary Record an anonymous page view (for analytics)
 */
export const recordPageView = async (pageViewInput: PageViewInput, options?: RequestInit): Promise<PageViewRecorded> => {

  return customFetch<PageViewRecorded>(getRecordPageViewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pageViewInput,)
  }
);}




export const getRecordPageViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPageView>>, TError,{data: BodyType<PageViewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordPageView>>, TError,{data: BodyType<PageViewInput>}, TContext> => {

const mutationKey = ['recordPageView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPageView>>, {data: BodyType<PageViewInput>}> = (props) => {
          const {data} = props ?? {};

          return  recordPageView(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordPageViewMutationResult = NonNullable<Awaited<ReturnType<typeof recordPageView>>>
    export type RecordPageViewMutationBody = BodyType<PageViewInput>
    export type RecordPageViewMutationError = ErrorType<unknown>

    /**
 * @summary Record an anonymous page view (for analytics)
 */
export const useRecordPageView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPageView>>, TError,{data: BodyType<PageViewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordPageView>>,
        TError,
        {data: BodyType<PageViewInput>},
        TContext
      > => {
      return useMutation(getRecordPageViewMutationOptions(options));
    }

export const getSubmitContactUrl = () => {




  return `/api/contact`
}

/**
 * @summary Submit contact form
 */
export const submitContact = async (contactInput: ContactInput, options?: RequestInit): Promise<ContactResult> => {

  return customFetch<ContactResult>(getSubmitContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contactInput,)
  }
);}




export const getSubmitContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext> => {

const mutationKey = ['submitContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitContact>>, {data: BodyType<ContactInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitContactMutationResult = NonNullable<Awaited<ReturnType<typeof submitContact>>>
    export type SubmitContactMutationBody = BodyType<ContactInput>
    export type SubmitContactMutationError = ErrorType<unknown>

    /**
 * @summary Submit contact form
 */
export const useSubmitContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitContact>>,
        TError,
        {data: BodyType<ContactInput>},
        TContext
      > => {
      return useMutation(getSubmitContactMutationOptions(options));
    }

export const getGetSiteSettingsUrl = () => {




  return `/api/site-settings`
}

/**
 * @summary Get public site settings (contact info)
 */
export const getSiteSettings = async ( options?: RequestInit): Promise<SiteSettings> => {

  return customFetch<SiteSettings>(getGetSiteSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSiteSettingsQueryKey = () => {
    return [
    `/api/site-settings`
    ] as const;
    }


export const getGetSiteSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSiteSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSiteSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSiteSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSiteSettings>>> = ({ signal }) => getSiteSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSiteSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSiteSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSiteSettings>>>
export type GetSiteSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get public site settings (contact info)
 */

export function useGetSiteSettings<TData = Awaited<ReturnType<typeof getSiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSiteSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSiteSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSiteSettingsUrl = () => {




  return `/api/admin/site-settings`
}

/**
 * @summary Update site settings (contact info)
 */
export const updateSiteSettings = async (siteSettingsUpdate: SiteSettingsUpdate, options?: RequestInit): Promise<SiteSettings> => {

  return customFetch<SiteSettings>(getUpdateSiteSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      siteSettingsUpdate,)
  }
);}




export const getUpdateSiteSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteSettings>>, TError,{data: BodyType<SiteSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSiteSettings>>, TError,{data: BodyType<SiteSettingsUpdate>}, TContext> => {

const mutationKey = ['updateSiteSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSiteSettings>>, {data: BodyType<SiteSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateSiteSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSiteSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSiteSettings>>>
    export type UpdateSiteSettingsMutationBody = BodyType<SiteSettingsUpdate>
    export type UpdateSiteSettingsMutationError = ErrorType<void>

    /**
 * @summary Update site settings (contact info)
 */
export const useUpdateSiteSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteSettings>>, TError,{data: BodyType<SiteSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSiteSettings>>,
        TError,
        {data: BodyType<SiteSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSiteSettingsMutationOptions(options));
    }

export const getGetContentUrl = () => {




  return `/api/content`
}

/**
 * @summary Get public editable site content blocks
 */
export const getContent = async ( options?: RequestInit): Promise<ContentBlocks> => {

  return customFetch<ContentBlocks>(getGetContentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContentQueryKey = () => {
    return [
    `/api/content`
    ] as const;
    }


export const getGetContentQueryOptions = <TData = Awaited<ReturnType<typeof getContent>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContent>>> = ({ signal }) => getContent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetContentQueryResult = NonNullable<Awaited<ReturnType<typeof getContent>>>
export type GetContentQueryError = ErrorType<unknown>


/**
 * @summary Get public editable site content blocks
 */

export function useGetContent<TData = Awaited<ReturnType<typeof getContent>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetContentQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateContentUrl = () => {




  return `/api/admin/content`
}

/**
 * @summary Update editable site content blocks
 */
export const updateContent = async (contentUpdate: ContentUpdate, options?: RequestInit): Promise<ContentBlocks> => {

  return customFetch<ContentBlocks>(getUpdateContentUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contentUpdate,)
  }
);}




export const getUpdateContentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContent>>, TError,{data: BodyType<ContentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContent>>, TError,{data: BodyType<ContentUpdate>}, TContext> => {

const mutationKey = ['updateContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContent>>, {data: BodyType<ContentUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContentMutationResult = NonNullable<Awaited<ReturnType<typeof updateContent>>>
    export type UpdateContentMutationBody = BodyType<ContentUpdate>
    export type UpdateContentMutationError = ErrorType<void>

    /**
 * @summary Update editable site content blocks
 */
export const useUpdateContent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContent>>, TError,{data: BodyType<ContentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateContent>>,
        TError,
        {data: BodyType<ContentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateContentMutationOptions(options));
    }

export const getAdminLoginUrl = () => {




  return `/api/admin/login`
}

/**
 * @summary Admin login
 */
export const adminLogin = async (adminCredentials: AdminCredentials, options?: RequestInit): Promise<AdminUser> => {

  return customFetch<AdminUser>(getAdminLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminCredentials,)
  }
);}




export const getAdminLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLogin>>, TError,{data: BodyType<AdminCredentials>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminLogin>>, TError,{data: BodyType<AdminCredentials>}, TContext> => {

const mutationKey = ['adminLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLogin>>, {data: BodyType<AdminCredentials>}> = (props) => {
          const {data} = props ?? {};

          return  adminLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminLoginMutationResult = NonNullable<Awaited<ReturnType<typeof adminLogin>>>
    export type AdminLoginMutationBody = BodyType<AdminCredentials>
    export type AdminLoginMutationError = ErrorType<void>

    /**
 * @summary Admin login
 */
export const useAdminLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLogin>>, TError,{data: BodyType<AdminCredentials>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminLogin>>,
        TError,
        {data: BodyType<AdminCredentials>},
        TContext
      > => {
      return useMutation(getAdminLoginMutationOptions(options));
    }

export const getAdminLogoutUrl = () => {




  return `/api/admin/logout`
}

/**
 * @summary Admin logout
 */
export const adminLogout = async ( options?: RequestInit): Promise<SimpleMessage> => {

  return customFetch<SimpleMessage>(getAdminLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAdminLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminLogout>>, TError,void, TContext> => {

const mutationKey = ['adminLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLogout>>, void> = () => {


          return  adminLogout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof adminLogout>>>

    export type AdminLogoutMutationError = ErrorType<unknown>

    /**
 * @summary Admin logout
 */
export const useAdminLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAdminLogoutMutationOptions(options));
    }

export const getGetAdminMeUrl = () => {




  return `/api/admin/me`
}

/**
 * @summary Get current admin session
 */
export const getAdminMe = async ( options?: RequestInit): Promise<AdminUser> => {

  return customFetch<AdminUser>(getGetAdminMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMeQueryKey = () => {
    return [
    `/api/admin/me`
    ] as const;
    }


export const getGetAdminMeQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMe>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMe>>> = ({ signal }) => getAdminMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMe>>>
export type GetAdminMeQueryError = ErrorType<void>


/**
 * @summary Get current admin session
 */

export function useGetAdminMe<TData = Awaited<ReturnType<typeof getAdminMe>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminAnalyticsUrl = (params?: GetAdminAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/analytics?${stringifiedParams}` : `/api/admin/analytics`
}

/**
 * @summary Get website analytics
 */
export const getAdminAnalytics = async (params?: GetAdminAnalyticsParams, options?: RequestInit): Promise<AnalyticsResult> => {

  return customFetch<AnalyticsResult>(getGetAdminAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAnalyticsQueryKey = (params?: GetAdminAnalyticsParams,) => {
    return [
    `/api/admin/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAnalytics>>, TError = ErrorType<void>>(params?: GetAdminAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAnalytics>>> = ({ signal }) => getAdminAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAnalytics>>>
export type GetAdminAnalyticsQueryError = ErrorType<void>


/**
 * @summary Get website analytics
 */

export function useGetAdminAnalytics<TData = Awaited<ReturnType<typeof getAdminAnalytics>>, TError = ErrorType<void>>(
 params?: GetAdminAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAdminListAffiliatesUrl = (params?: AdminListAffiliatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/affiliates?${stringifiedParams}` : `/api/admin/affiliates`
}

/**
 * @summary List all affiliates (including inactive)
 */
export const adminListAffiliates = async (params?: AdminListAffiliatesParams, options?: RequestInit): Promise<PaginatedAffiliates> => {

  return customFetch<PaginatedAffiliates>(getAdminListAffiliatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListAffiliatesQueryKey = (params?: AdminListAffiliatesParams,) => {
    return [
    `/api/admin/affiliates`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListAffiliatesQueryOptions = <TData = Awaited<ReturnType<typeof adminListAffiliates>>, TError = ErrorType<void>>(params?: AdminListAffiliatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListAffiliates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListAffiliatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListAffiliates>>> = ({ signal }) => adminListAffiliates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListAffiliates>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListAffiliatesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListAffiliates>>>
export type AdminListAffiliatesQueryError = ErrorType<void>


/**
 * @summary List all affiliates (including inactive)
 */

export function useAdminListAffiliates<TData = Awaited<ReturnType<typeof adminListAffiliates>>, TError = ErrorType<void>>(
 params?: AdminListAffiliatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListAffiliates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListAffiliatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAffiliateUrl = () => {




  return `/api/admin/affiliates`
}

/**
 * @summary Create a new affiliate
 */
export const createAffiliate = async (affiliateInput: AffiliateInput, options?: RequestInit): Promise<Affiliate> => {

  return customFetch<Affiliate>(getCreateAffiliateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      affiliateInput,)
  }
);}




export const getCreateAffiliateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliate>>, TError,{data: BodyType<AffiliateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAffiliate>>, TError,{data: BodyType<AffiliateInput>}, TContext> => {

const mutationKey = ['createAffiliate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAffiliate>>, {data: BodyType<AffiliateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAffiliate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof createAffiliate>>>
    export type CreateAffiliateMutationBody = BodyType<AffiliateInput>
    export type CreateAffiliateMutationError = ErrorType<void>

    /**
 * @summary Create a new affiliate
 */
export const useCreateAffiliate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliate>>, TError,{data: BodyType<AffiliateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAffiliate>>,
        TError,
        {data: BodyType<AffiliateInput>},
        TContext
      > => {
      return useMutation(getCreateAffiliateMutationOptions(options));
    }

export const getUpdateAffiliateUrl = (slug: string,) => {




  return `/api/admin/affiliates/${slug}`
}

/**
 * @summary Update an affiliate
 */
export const updateAffiliate = async (slug: string,
    affiliateUpdate: AffiliateUpdate, options?: RequestInit): Promise<Affiliate> => {

  return customFetch<Affiliate>(getUpdateAffiliateUrl(slug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      affiliateUpdate,)
  }
);}




export const getUpdateAffiliateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAffiliate>>, TError,{slug: string;data: BodyType<AffiliateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAffiliate>>, TError,{slug: string;data: BodyType<AffiliateUpdate>}, TContext> => {

const mutationKey = ['updateAffiliate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAffiliate>>, {slug: string;data: BodyType<AffiliateUpdate>}> = (props) => {
          const {slug,data} = props ?? {};

          return  updateAffiliate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof updateAffiliate>>>
    export type UpdateAffiliateMutationBody = BodyType<AffiliateUpdate>
    export type UpdateAffiliateMutationError = ErrorType<void>

    /**
 * @summary Update an affiliate
 */
export const useUpdateAffiliate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAffiliate>>, TError,{slug: string;data: BodyType<AffiliateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAffiliate>>,
        TError,
        {slug: string;data: BodyType<AffiliateUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAffiliateMutationOptions(options));
    }

export const getDeleteAffiliateUrl = (slug: string,) => {




  return `/api/admin/affiliates/${slug}`
}

/**
 * @summary Delete an affiliate
 */
export const deleteAffiliate = async (slug: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAffiliateUrl(slug),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAffiliateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAffiliate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAffiliate>>, TError,{slug: string}, TContext> => {

const mutationKey = ['deleteAffiliate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAffiliate>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  deleteAffiliate(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAffiliateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAffiliate>>>

    export type DeleteAffiliateMutationError = ErrorType<void>

    /**
 * @summary Delete an affiliate
 */
export const useDeleteAffiliate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAffiliate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAffiliate>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getDeleteAffiliateMutationOptions(options));
    }

export const getCreateAffiliateLinkUrl = (slug: string,) => {




  return `/api/admin/affiliates/${slug}/links`
}

/**
 * @summary Add a link to an affiliate
 */
export const createAffiliateLink = async (slug: string,
    affiliateLinkInput: AffiliateLinkInput, options?: RequestInit): Promise<AffiliateLink> => {

  return customFetch<AffiliateLink>(getCreateAffiliateLinkUrl(slug),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      affiliateLinkInput,)
  }
);}




export const getCreateAffiliateLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliateLink>>, TError,{slug: string;data: BodyType<AffiliateLinkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAffiliateLink>>, TError,{slug: string;data: BodyType<AffiliateLinkInput>}, TContext> => {

const mutationKey = ['createAffiliateLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAffiliateLink>>, {slug: string;data: BodyType<AffiliateLinkInput>}> = (props) => {
          const {slug,data} = props ?? {};

          return  createAffiliateLink(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAffiliateLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createAffiliateLink>>>
    export type CreateAffiliateLinkMutationBody = BodyType<AffiliateLinkInput>
    export type CreateAffiliateLinkMutationError = ErrorType<void>

    /**
 * @summary Add a link to an affiliate
 */
export const useCreateAffiliateLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAffiliateLink>>, TError,{slug: string;data: BodyType<AffiliateLinkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAffiliateLink>>,
        TError,
        {slug: string;data: BodyType<AffiliateLinkInput>},
        TContext
      > => {
      return useMutation(getCreateAffiliateLinkMutationOptions(options));
    }

export const getUpdateAffiliateLinkUrl = (id: number,) => {




  return `/api/admin/affiliate-links/${id}`
}

/**
 * @summary Update an affiliate link
 */
export const updateAffiliateLink = async (id: number,
    affiliateLinkUpdate: AffiliateLinkUpdate, options?: RequestInit): Promise<AffiliateLink> => {

  return customFetch<AffiliateLink>(getUpdateAffiliateLinkUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      affiliateLinkUpdate,)
  }
);}




export const getUpdateAffiliateLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAffiliateLink>>, TError,{id: number;data: BodyType<AffiliateLinkUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAffiliateLink>>, TError,{id: number;data: BodyType<AffiliateLinkUpdate>}, TContext> => {

const mutationKey = ['updateAffiliateLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAffiliateLink>>, {id: number;data: BodyType<AffiliateLinkUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAffiliateLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAffiliateLinkMutationResult = NonNullable<Awaited<ReturnType<typeof updateAffiliateLink>>>
    export type UpdateAffiliateLinkMutationBody = BodyType<AffiliateLinkUpdate>
    export type UpdateAffiliateLinkMutationError = ErrorType<void>

    /**
 * @summary Update an affiliate link
 */
export const useUpdateAffiliateLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAffiliateLink>>, TError,{id: number;data: BodyType<AffiliateLinkUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAffiliateLink>>,
        TError,
        {id: number;data: BodyType<AffiliateLinkUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAffiliateLinkMutationOptions(options));
    }

export const getDeleteAffiliateLinkUrl = (id: number,) => {




  return `/api/admin/affiliate-links/${id}`
}

/**
 * @summary Delete an affiliate link
 */
export const deleteAffiliateLink = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAffiliateLinkUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAffiliateLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAffiliateLink>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAffiliateLink>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAffiliateLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAffiliateLink>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAffiliateLink(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAffiliateLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAffiliateLink>>>

    export type DeleteAffiliateLinkMutationError = ErrorType<void>

    /**
 * @summary Delete an affiliate link
 */
export const useDeleteAffiliateLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAffiliateLink>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAffiliateLink>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAffiliateLinkMutationOptions(options));
    }

export const getAdminListEventsUrl = (params?: AdminListEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/events?${stringifiedParams}` : `/api/admin/events`
}

/**
 * @summary List all events (including inactive)
 */
export const adminListEvents = async (params?: AdminListEventsParams, options?: RequestInit): Promise<PaginatedEvents> => {

  return customFetch<PaginatedEvents>(getAdminListEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListEventsQueryKey = (params?: AdminListEventsParams,) => {
    return [
    `/api/admin/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListEventsQueryOptions = <TData = Awaited<ReturnType<typeof adminListEvents>>, TError = ErrorType<void>>(params?: AdminListEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListEvents>>> = ({ signal }) => adminListEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListEventsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListEvents>>>
export type AdminListEventsQueryError = ErrorType<void>


/**
 * @summary List all events (including inactive)
 */

export function useAdminListEvents<TData = Awaited<ReturnType<typeof adminListEvents>>, TError = ErrorType<void>>(
 params?: AdminListEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEventUrl = () => {




  return `/api/admin/events`
}

/**
 * @summary Create a new event
 */
export const createEvent = async (eventInput: EventInput, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getCreateEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventInput,)
  }
);}




export const getCreateEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext> => {

const mutationKey = ['createEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEvent>>, {data: BodyType<EventInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEventMutationResult = NonNullable<Awaited<ReturnType<typeof createEvent>>>
    export type CreateEventMutationBody = BodyType<EventInput>
    export type CreateEventMutationError = ErrorType<void>

    /**
 * @summary Create a new event
 */
export const useCreateEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEvent>>,
        TError,
        {data: BodyType<EventInput>},
        TContext
      > => {
      return useMutation(getCreateEventMutationOptions(options));
    }

export const getUpdateEventUrl = (slug: string,) => {




  return `/api/admin/events/${slug}`
}

/**
 * @summary Update an event
 */
export const updateEvent = async (slug: string,
    eventUpdate: EventUpdate, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getUpdateEventUrl(slug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventUpdate,)
  }
);}




export const getUpdateEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{slug: string;data: BodyType<EventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{slug: string;data: BodyType<EventUpdate>}, TContext> => {

const mutationKey = ['updateEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEvent>>, {slug: string;data: BodyType<EventUpdate>}> = (props) => {
          const {slug,data} = props ?? {};

          return  updateEvent(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvent>>>
    export type UpdateEventMutationBody = BodyType<EventUpdate>
    export type UpdateEventMutationError = ErrorType<void>

    /**
 * @summary Update an event
 */
export const useUpdateEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{slug: string;data: BodyType<EventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEvent>>,
        TError,
        {slug: string;data: BodyType<EventUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEventMutationOptions(options));
    }

export const getDeleteEventUrl = (slug: string,) => {




  return `/api/admin/events/${slug}`
}

/**
 * @summary Delete an event
 */
export const deleteEvent = async (slug: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteEventUrl(slug),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{slug: string}, TContext> => {

const mutationKey = ['deleteEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  deleteEvent(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>

    export type DeleteEventMutationError = ErrorType<void>

    /**
 * @summary Delete an event
 */
export const useDeleteEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getDeleteEventMutationOptions(options));
    }

export const getGetEventParticipantsUrl = (slug: string,) => {




  return `/api/admin/events/${slug}/participants`
}

/**
 * @summary Get tagged affiliates for an event
 */
export const getEventParticipants = async (slug: string, options?: RequestInit): Promise<number[]> => {

  return customFetch<number[]>(getGetEventParticipantsUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventParticipantsQueryKey = (slug: string,) => {
    return [
    `/api/admin/events/${slug}/participants`
    ] as const;
    }


export const getGetEventParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof getEventParticipants>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventParticipants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventParticipantsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventParticipants>>> = ({ signal }) => getEventParticipants(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventParticipants>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventParticipants>>>
export type GetEventParticipantsQueryError = ErrorType<void>


/**
 * @summary Get tagged affiliates for an event
 */

export function useGetEventParticipants<TData = Awaited<ReturnType<typeof getEventParticipants>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventParticipants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventParticipantsQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetEventParticipantsUrl = (slug: string,) => {




  return `/api/admin/events/${slug}/participants`
}

/**
 * @summary Set tagged affiliates for an event
 */
export const setEventParticipants = async (slug: string,
    setParticipantsBody: SetParticipantsBody, options?: RequestInit): Promise<number[]> => {

  return customFetch<number[]>(getSetEventParticipantsUrl(slug),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setParticipantsBody,)
  }
);}




export const getSetEventParticipantsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEventParticipants>>, TError,{slug: string;data: BodyType<SetParticipantsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setEventParticipants>>, TError,{slug: string;data: BodyType<SetParticipantsBody>}, TContext> => {

const mutationKey = ['setEventParticipants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setEventParticipants>>, {slug: string;data: BodyType<SetParticipantsBody>}> = (props) => {
          const {slug,data} = props ?? {};

          return  setEventParticipants(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetEventParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof setEventParticipants>>>
    export type SetEventParticipantsMutationBody = BodyType<SetParticipantsBody>
    export type SetEventParticipantsMutationError = ErrorType<void>

    /**
 * @summary Set tagged affiliates for an event
 */
export const useSetEventParticipants = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEventParticipants>>, TError,{slug: string;data: BodyType<SetParticipantsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setEventParticipants>>,
        TError,
        {slug: string;data: BodyType<SetParticipantsBody>},
        TContext
      > => {
      return useMutation(getSetEventParticipantsMutationOptions(options));
    }

export const getListPartnersUrl = (params?: ListPartnersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/partners?${stringifiedParams}` : `/api/partners`
}

/**
 * @summary List active partners
 */
export const listPartners = async (params?: ListPartnersParams, options?: RequestInit): Promise<PaginatedPartners> => {

  return customFetch<PaginatedPartners>(getListPartnersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPartnersQueryKey = (params?: ListPartnersParams,) => {
    return [
    `/api/partners`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof listPartners>>, TError = ErrorType<unknown>>(params?: ListPartnersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPartnersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartners>>> = ({ signal }) => listPartners(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof listPartners>>>
export type ListPartnersQueryError = ErrorType<unknown>


/**
 * @summary List active partners
 */

export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = ErrorType<unknown>>(
 params?: ListPartnersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPartnersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPartnerUrl = (slug: string,) => {




  return `/api/partners/${slug}`
}

/**
 * @summary Get a single partner by slug
 */
export const getPartner = async (slug: string, options?: RequestInit): Promise<Partner> => {

  return customFetch<Partner>(getGetPartnerUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPartnerQueryKey = (slug: string,) => {
    return [
    `/api/partners/${slug}`
    ] as const;
    }


export const getGetPartnerQueryOptions = <TData = Awaited<ReturnType<typeof getPartner>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnerQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartner>>> = ({ signal }) => getPartner(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getPartner>>>
export type GetPartnerQueryError = ErrorType<void>


/**
 * @summary Get a single partner by slug
 */

export function useGetPartner<TData = Awaited<ReturnType<typeof getPartner>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPartnerQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAdminListPartnersUrl = (params?: AdminListPartnersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/partners?${stringifiedParams}` : `/api/admin/partners`
}

/**
 * @summary List all partners (including inactive)
 */
export const adminListPartners = async (params?: AdminListPartnersParams, options?: RequestInit): Promise<PaginatedPartners> => {

  return customFetch<PaginatedPartners>(getAdminListPartnersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListPartnersQueryKey = (params?: AdminListPartnersParams,) => {
    return [
    `/api/admin/partners`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof adminListPartners>>, TError = ErrorType<void>>(params?: AdminListPartnersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPartners>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListPartnersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListPartners>>> = ({ signal }) => adminListPartners(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListPartners>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof adminListPartners>>>
export type AdminListPartnersQueryError = ErrorType<void>


/**
 * @summary List all partners (including inactive)
 */

export function useAdminListPartners<TData = Awaited<ReturnType<typeof adminListPartners>>, TError = ErrorType<void>>(
 params?: AdminListPartnersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPartners>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListPartnersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePartnerUrl = () => {




  return `/api/admin/partners`
}

/**
 * @summary Create a new partner
 */
export const createPartner = async (partnerInput: PartnerInput, options?: RequestInit): Promise<Partner> => {

  return customFetch<Partner>(getCreatePartnerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partnerInput,)
  }
);}




export const getCreatePartnerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPartner>>, TError,{data: BodyType<PartnerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPartner>>, TError,{data: BodyType<PartnerInput>}, TContext> => {

const mutationKey = ['createPartner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPartner>>, {data: BodyType<PartnerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPartner(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof createPartner>>>
    export type CreatePartnerMutationBody = BodyType<PartnerInput>
    export type CreatePartnerMutationError = ErrorType<void>

    /**
 * @summary Create a new partner
 */
export const useCreatePartner = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPartner>>, TError,{data: BodyType<PartnerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPartner>>,
        TError,
        {data: BodyType<PartnerInput>},
        TContext
      > => {
      return useMutation(getCreatePartnerMutationOptions(options));
    }

export const getUpdatePartnerUrl = (slug: string,) => {




  return `/api/admin/partners/${slug}`
}

/**
 * @summary Update a partner
 */
export const updatePartner = async (slug: string,
    partnerUpdate: PartnerUpdate, options?: RequestInit): Promise<Partner> => {

  return customFetch<Partner>(getUpdatePartnerUrl(slug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partnerUpdate,)
  }
);}




export const getUpdatePartnerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePartner>>, TError,{slug: string;data: BodyType<PartnerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePartner>>, TError,{slug: string;data: BodyType<PartnerUpdate>}, TContext> => {

const mutationKey = ['updatePartner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePartner>>, {slug: string;data: BodyType<PartnerUpdate>}> = (props) => {
          const {slug,data} = props ?? {};

          return  updatePartner(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof updatePartner>>>
    export type UpdatePartnerMutationBody = BodyType<PartnerUpdate>
    export type UpdatePartnerMutationError = ErrorType<void>

    /**
 * @summary Update a partner
 */
export const useUpdatePartner = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePartner>>, TError,{slug: string;data: BodyType<PartnerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePartner>>,
        TError,
        {slug: string;data: BodyType<PartnerUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePartnerMutationOptions(options));
    }

export const getDeletePartnerUrl = (slug: string,) => {




  return `/api/admin/partners/${slug}`
}

/**
 * @summary Delete a partner
 */
export const deletePartner = async (slug: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePartnerUrl(slug),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePartnerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePartner>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePartner>>, TError,{slug: string}, TContext> => {

const mutationKey = ['deletePartner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePartner>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  deletePartner(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof deletePartner>>>

    export type DeletePartnerMutationError = ErrorType<void>

    /**
 * @summary Delete a partner
 */
export const useDeletePartner = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePartner>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePartner>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getDeletePartnerMutationOptions(options));
    }

export const getGetPartnerParticipantsUrl = (slug: string,) => {




  return `/api/admin/partners/${slug}/participants`
}

/**
 * @summary Get tagged affiliates for a partner
 */
export const getPartnerParticipants = async (slug: string, options?: RequestInit): Promise<number[]> => {

  return customFetch<number[]>(getGetPartnerParticipantsUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPartnerParticipantsQueryKey = (slug: string,) => {
    return [
    `/api/admin/partners/${slug}/participants`
    ] as const;
    }


export const getGetPartnerParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof getPartnerParticipants>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPartnerParticipants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnerParticipantsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerParticipants>>> = ({ signal }) => getPartnerParticipants(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnerParticipants>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPartnerParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnerParticipants>>>
export type GetPartnerParticipantsQueryError = ErrorType<void>


/**
 * @summary Get tagged affiliates for a partner
 */

export function useGetPartnerParticipants<TData = Awaited<ReturnType<typeof getPartnerParticipants>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPartnerParticipants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPartnerParticipantsQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetPartnerParticipantsUrl = (slug: string,) => {




  return `/api/admin/partners/${slug}/participants`
}

/**
 * @summary Set tagged affiliates for a partner
 */
export const setPartnerParticipants = async (slug: string,
    setParticipantsBody: SetParticipantsBody, options?: RequestInit): Promise<number[]> => {

  return customFetch<number[]>(getSetPartnerParticipantsUrl(slug),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setParticipantsBody,)
  }
);}




export const getSetPartnerParticipantsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPartnerParticipants>>, TError,{slug: string;data: BodyType<SetParticipantsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPartnerParticipants>>, TError,{slug: string;data: BodyType<SetParticipantsBody>}, TContext> => {

const mutationKey = ['setPartnerParticipants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPartnerParticipants>>, {slug: string;data: BodyType<SetParticipantsBody>}> = (props) => {
          const {slug,data} = props ?? {};

          return  setPartnerParticipants(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPartnerParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof setPartnerParticipants>>>
    export type SetPartnerParticipantsMutationBody = BodyType<SetParticipantsBody>
    export type SetPartnerParticipantsMutationError = ErrorType<void>

    /**
 * @summary Set tagged affiliates for a partner
 */
export const useSetPartnerParticipants = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPartnerParticipants>>, TError,{slug: string;data: BodyType<SetParticipantsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPartnerParticipants>>,
        TError,
        {slug: string;data: BodyType<SetParticipantsBody>},
        TContext
      > => {
      return useMutation(getSetPartnerParticipantsMutationOptions(options));
    }

export const getAdminListUsersUrl = () => {




  return `/api/admin/users`
}

/**
 * @summary List all admin users
 */
export const adminListUsers = async ( options?: RequestInit): Promise<AdminUser[]> => {

  return customFetch<AdminUser[]>(getAdminListUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListUsersQueryKey = () => {
    return [
    `/api/admin/users`
    ] as const;
    }


export const getAdminListUsersQueryOptions = <TData = Awaited<ReturnType<typeof adminListUsers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUsers>>> = ({ signal }) => adminListUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof adminListUsers>>>
export type AdminListUsersQueryError = ErrorType<void>


/**
 * @summary List all admin users
 */

export function useAdminListUsers<TData = Awaited<ReturnType<typeof adminListUsers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAdminUserUrl = () => {




  return `/api/admin/users`
}

/**
 * @summary Create a new admin user
 */
export const createAdminUser = async (adminCredentials: AdminCredentials, options?: RequestInit): Promise<AdminUser> => {

  return customFetch<AdminUser>(getCreateAdminUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminCredentials,)
  }
);}




export const getCreateAdminUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,{data: BodyType<AdminCredentials>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,{data: BodyType<AdminCredentials>}, TContext> => {

const mutationKey = ['createAdminUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminUser>>, {data: BodyType<AdminCredentials>}> = (props) => {
          const {data} = props ?? {};

          return  createAdminUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminUser>>>
    export type CreateAdminUserMutationBody = BodyType<AdminCredentials>
    export type CreateAdminUserMutationError = ErrorType<void>

    /**
 * @summary Create a new admin user
 */
export const useCreateAdminUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,{data: BodyType<AdminCredentials>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminUser>>,
        TError,
        {data: BodyType<AdminCredentials>},
        TContext
      > => {
      return useMutation(getCreateAdminUserMutationOptions(options));
    }

export const getUpdateAdminUserUrl = (id: number,) => {




  return `/api/admin/users/${id}`
}

/**
 * @summary Update an admin user's username and/or password
 */
export const updateAdminUser = async (id: number,
    updateAdminCredentials: UpdateAdminCredentials, options?: RequestInit): Promise<AdminUser> => {

  return customFetch<AdminUser>(getUpdateAdminUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAdminCredentials,)
  }
);}




export const getUpdateAdminUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,{id: number;data: BodyType<UpdateAdminCredentials>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,{id: number;data: BodyType<UpdateAdminCredentials>}, TContext> => {

const mutationKey = ['updateAdminUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminUser>>, {id: number;data: BodyType<UpdateAdminCredentials>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminUser>>>
    export type UpdateAdminUserMutationBody = BodyType<UpdateAdminCredentials>
    export type UpdateAdminUserMutationError = ErrorType<void>

    /**
 * @summary Update an admin user's username and/or password
 */
export const useUpdateAdminUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,{id: number;data: BodyType<UpdateAdminCredentials>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminUser>>,
        TError,
        {id: number;data: BodyType<UpdateAdminCredentials>},
        TContext
      > => {
      return useMutation(getUpdateAdminUserMutationOptions(options));
    }

export const getDeleteAdminUserUrl = (id: number,) => {




  return `/api/admin/users/${id}`
}

/**
 * @summary Delete an admin user
 */
export const deleteAdminUser = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAdminUserUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAdminUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAdminUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminUser>>>

    export type DeleteAdminUserMutationError = ErrorType<void>

    /**
 * @summary Delete an admin user
 */
export const useDeleteAdminUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAdminUserMutationOptions(options));
    }

export const getAdminListMessagesUrl = () => {




  return `/api/admin/messages`
}

/**
 * @summary List contact form submissions
 */
export const adminListMessages = async ( options?: RequestInit): Promise<ContactMessage[]> => {

  return customFetch<ContactMessage[]>(getAdminListMessagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListMessagesQueryKey = () => {
    return [
    `/api/admin/messages`
    ] as const;
    }


export const getAdminListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof adminListMessages>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListMessagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListMessages>>> = ({ signal }) => adminListMessages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListMessages>>>
export type AdminListMessagesQueryError = ErrorType<void>


/**
 * @summary List contact form submissions
 */

export function useAdminListMessages<TData = Awaited<ReturnType<typeof adminListMessages>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListMessagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetUnreadMessageCountUrl = () => {




  return `/api/admin/messages/unread-count`
}

/**
 * @summary Count unread contact submissions
 */
export const getUnreadMessageCount = async ( options?: RequestInit): Promise<UnreadCount> => {

  return customFetch<UnreadCount>(getGetUnreadMessageCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnreadMessageCountQueryKey = () => {
    return [
    `/api/admin/messages/unread-count`
    ] as const;
    }


export const getGetUnreadMessageCountQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadMessageCount>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnreadMessageCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadMessageCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadMessageCount>>> = ({ signal }) => getUnreadMessageCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadMessageCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUnreadMessageCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadMessageCount>>>
export type GetUnreadMessageCountQueryError = ErrorType<void>


/**
 * @summary Count unread contact submissions
 */

export function useGetUnreadMessageCount<TData = Awaited<ReturnType<typeof getUnreadMessageCount>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnreadMessageCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUnreadMessageCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMessageUrl = (id: number,) => {




  return `/api/admin/messages/${id}`
}

/**
 * @summary Mark a contact message read/handled
 */
export const updateMessage = async (id: number,
    messageUpdate: MessageUpdate, options?: RequestInit): Promise<ContactMessage> => {

  return customFetch<ContactMessage>(getUpdateMessageUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      messageUpdate,)
  }
);}




export const getUpdateMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessage>>, TError,{id: number;data: BodyType<MessageUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMessage>>, TError,{id: number;data: BodyType<MessageUpdate>}, TContext> => {

const mutationKey = ['updateMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMessage>>, {id: number;data: BodyType<MessageUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMessageMutationResult = NonNullable<Awaited<ReturnType<typeof updateMessage>>>
    export type UpdateMessageMutationBody = BodyType<MessageUpdate>
    export type UpdateMessageMutationError = ErrorType<void>

    /**
 * @summary Mark a contact message read/handled
 */
export const useUpdateMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessage>>, TError,{id: number;data: BodyType<MessageUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMessage>>,
        TError,
        {id: number;data: BodyType<MessageUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMessageMutationOptions(options));
    }

export const getDeleteMessageUrl = (id: number,) => {




  return `/api/admin/messages/${id}`
}

/**
 * @summary Delete a contact message
 */
export const deleteMessage = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMessageUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMessage>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMessage>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMessage>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMessage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMessageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMessage>>>

    export type DeleteMessageMutationError = ErrorType<void>

    /**
 * @summary Delete a contact message
 */
export const useDeleteMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMessage>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMessage>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMessageMutationOptions(options));
    }

export const getReorderAffiliatesUrl = () => {




  return `/api/admin/affiliates/reorder`
}

/**
 * @summary Persist a new display order for affiliates
 */
export const reorderAffiliates = async (reorderBody: ReorderBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getReorderAffiliatesUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderBody,)
  }
);}




export const getReorderAffiliatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderAffiliates>>, TError,{data: BodyType<ReorderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderAffiliates>>, TError,{data: BodyType<ReorderBody>}, TContext> => {

const mutationKey = ['reorderAffiliates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderAffiliates>>, {data: BodyType<ReorderBody>}> = (props) => {
          const {data} = props ?? {};

          return  reorderAffiliates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderAffiliatesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderAffiliates>>>
    export type ReorderAffiliatesMutationBody = BodyType<ReorderBody>
    export type ReorderAffiliatesMutationError = ErrorType<void>

    /**
 * @summary Persist a new display order for affiliates
 */
export const useReorderAffiliates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderAffiliates>>, TError,{data: BodyType<ReorderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderAffiliates>>,
        TError,
        {data: BodyType<ReorderBody>},
        TContext
      > => {
      return useMutation(getReorderAffiliatesMutationOptions(options));
    }

export const getBulkAffiliatesUrl = () => {




  return `/api/admin/affiliates/bulk`
}

/**
 * @summary Bulk activate/deactivate/delete affiliates
 */
export const bulkAffiliates = async (bulkActionBody: BulkActionBody, options?: RequestInit): Promise<BulkActionResult> => {

  return customFetch<BulkActionResult>(getBulkAffiliatesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkActionBody,)
  }
);}




export const getBulkAffiliatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAffiliates>>, TError,{data: BodyType<BulkActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAffiliates>>, TError,{data: BodyType<BulkActionBody>}, TContext> => {

const mutationKey = ['bulkAffiliates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAffiliates>>, {data: BodyType<BulkActionBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkAffiliates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAffiliatesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAffiliates>>>
    export type BulkAffiliatesMutationBody = BodyType<BulkActionBody>
    export type BulkAffiliatesMutationError = ErrorType<void>

    /**
 * @summary Bulk activate/deactivate/delete affiliates
 */
export const useBulkAffiliates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAffiliates>>, TError,{data: BodyType<BulkActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkAffiliates>>,
        TError,
        {data: BodyType<BulkActionBody>},
        TContext
      > => {
      return useMutation(getBulkAffiliatesMutationOptions(options));
    }

export const getReorderEventsUrl = () => {




  return `/api/admin/events/reorder`
}

/**
 * @summary Persist a new display order for events
 */
export const reorderEvents = async (reorderBody: ReorderBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getReorderEventsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderBody,)
  }
);}




export const getReorderEventsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderEvents>>, TError,{data: BodyType<ReorderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderEvents>>, TError,{data: BodyType<ReorderBody>}, TContext> => {

const mutationKey = ['reorderEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderEvents>>, {data: BodyType<ReorderBody>}> = (props) => {
          const {data} = props ?? {};

          return  reorderEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderEventsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderEvents>>>
    export type ReorderEventsMutationBody = BodyType<ReorderBody>
    export type ReorderEventsMutationError = ErrorType<void>

    /**
 * @summary Persist a new display order for events
 */
export const useReorderEvents = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderEvents>>, TError,{data: BodyType<ReorderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderEvents>>,
        TError,
        {data: BodyType<ReorderBody>},
        TContext
      > => {
      return useMutation(getReorderEventsMutationOptions(options));
    }

export const getBulkEventsUrl = () => {




  return `/api/admin/events/bulk`
}

/**
 * @summary Bulk activate/deactivate/delete events
 */
export const bulkEvents = async (bulkActionBody: BulkActionBody, options?: RequestInit): Promise<BulkActionResult> => {

  return customFetch<BulkActionResult>(getBulkEventsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkActionBody,)
  }
);}




export const getBulkEventsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkEvents>>, TError,{data: BodyType<BulkActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkEvents>>, TError,{data: BodyType<BulkActionBody>}, TContext> => {

const mutationKey = ['bulkEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkEvents>>, {data: BodyType<BulkActionBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkEventsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkEvents>>>
    export type BulkEventsMutationBody = BodyType<BulkActionBody>
    export type BulkEventsMutationError = ErrorType<void>

    /**
 * @summary Bulk activate/deactivate/delete events
 */
export const useBulkEvents = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkEvents>>, TError,{data: BodyType<BulkActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkEvents>>,
        TError,
        {data: BodyType<BulkActionBody>},
        TContext
      > => {
      return useMutation(getBulkEventsMutationOptions(options));
    }

export const getReorderPartnersUrl = () => {




  return `/api/admin/partners/reorder`
}

/**
 * @summary Persist a new display order for partners
 */
export const reorderPartners = async (reorderBody: ReorderBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getReorderPartnersUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderBody,)
  }
);}




export const getReorderPartnersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderPartners>>, TError,{data: BodyType<ReorderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderPartners>>, TError,{data: BodyType<ReorderBody>}, TContext> => {

const mutationKey = ['reorderPartners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderPartners>>, {data: BodyType<ReorderBody>}> = (props) => {
          const {data} = props ?? {};

          return  reorderPartners(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderPartnersMutationResult = NonNullable<Awaited<ReturnType<typeof reorderPartners>>>
    export type ReorderPartnersMutationBody = BodyType<ReorderBody>
    export type ReorderPartnersMutationError = ErrorType<void>

    /**
 * @summary Persist a new display order for partners
 */
export const useReorderPartners = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderPartners>>, TError,{data: BodyType<ReorderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderPartners>>,
        TError,
        {data: BodyType<ReorderBody>},
        TContext
      > => {
      return useMutation(getReorderPartnersMutationOptions(options));
    }

export const getBulkPartnersUrl = () => {




  return `/api/admin/partners/bulk`
}

/**
 * @summary Bulk activate/deactivate/delete partners
 */
export const bulkPartners = async (bulkActionBody: BulkActionBody, options?: RequestInit): Promise<BulkActionResult> => {

  return customFetch<BulkActionResult>(getBulkPartnersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkActionBody,)
  }
);}




export const getBulkPartnersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPartners>>, TError,{data: BodyType<BulkActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkPartners>>, TError,{data: BodyType<BulkActionBody>}, TContext> => {

const mutationKey = ['bulkPartners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkPartners>>, {data: BodyType<BulkActionBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkPartners(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkPartnersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkPartners>>>
    export type BulkPartnersMutationBody = BodyType<BulkActionBody>
    export type BulkPartnersMutationError = ErrorType<void>

    /**
 * @summary Bulk activate/deactivate/delete partners
 */
export const useBulkPartners = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkPartners>>, TError,{data: BodyType<BulkActionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkPartners>>,
        TError,
        {data: BodyType<BulkActionBody>},
        TContext
      > => {
      return useMutation(getBulkPartnersMutationOptions(options));
    }

export const getAdminUploadImageUrl = () => {




  return `/api/admin/uploads`
}

/**
 * @summary Upload an image (raw body); resized + stored server-side
 */
export const adminUploadImage = async (adminUploadImageBody: Blob, options?: RequestInit): Promise<UploadedImage> => {

  return customFetch<UploadedImage>(getAdminUploadImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'image/*', ...options?.headers },
    body: JSON.stringify(
      adminUploadImageBody,)
  }
);}




export const getAdminUploadImageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUploadImage>>, TError,{data: BodyType<Blob>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUploadImage>>, TError,{data: BodyType<Blob>}, TContext> => {

const mutationKey = ['adminUploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUploadImage>>, {data: BodyType<Blob>}> = (props) => {
          const {data} = props ?? {};

          return  adminUploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof adminUploadImage>>>
    export type AdminUploadImageMutationBody = BodyType<Blob>
    export type AdminUploadImageMutationError = ErrorType<void>

    /**
 * @summary Upload an image (raw body); resized + stored server-side
 */
export const useAdminUploadImage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUploadImage>>, TError,{data: BodyType<Blob>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUploadImage>>,
        TError,
        {data: BodyType<Blob>},
        TContext
      > => {
      return useMutation(getAdminUploadImageMutationOptions(options));
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve a stored upload (immutable, long-cached)
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<void>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(objectPath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<void>


/**
 * @summary Serve a stored upload (immutable, long-cached)
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<void>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







